module.exports = __webpack_public_path__ + "img/8.79b48827.svg";